module.exports = __webpack_public_path__ + "img/ic_batsu.792923f7.svg";